export default __webpack_public_path__ + "static/media/financialLaw.5bfc0201.svg";